<template>
    <div>
		  <div class="spinner-border" v-if = "isLoading" style = "margin-top:20%;margin-left:50%"></div>
		  <div style = "" v-else>
			  <form v-on:submit.prevent>
					  <div class="form-group row" >
						  <label class="col-sm-2 col-form-label">
							  Template
						  </label>
						  <div class="col-sm-9 pr-5">
							  <ckeditor v-model="editorDataToEdit"  :config="editorConfig" id = "textAreaEditor"
							 :editor-url = "templateURl + '/ckeditor_plugins/ckeditor.js'" @focus="onEditorFocus" ></ckeditor>
						  </div>
					  </div>
			  </form>
		  </div>
    </div>
</template>

<script>
import moment from "moment";
import Multiselect from "vue-multiselect";
import { templateURl } from '@/properties';
import {campaignTable} from './templates/campaignTable.js';
import {productTable} from './templates/productTable.js';
import {campaignGroupTemplate} from './templates/campaignGroupTemplate.js';
import {profileTable} from './templates/profileTable.js';





export default {
	name: "templateBuilder",
	components:{moment, Multiselect},
	props:["tokensList", "type", "editorData"],
	data(){
		return{
			campaignTable:campaignTable,
			productTable:productTable,
			templateURl:templateURl,
			type_list:[],
			type:null,
			title:"",
			isLoading:false,
			isEditPage:false,
			templateId:'',
			editorConfig:{
				toolbarGroups: [
	                { name: 'insert' },
	                { name: 'document', groups: ['mode'] },
					{ name: 'basicstyles'},
					{ name: 'paragraph', groups: [ 'align', 'list'] },
					{ name: 'styles'}
			 ],
			 removePlugins: 'iframe,pagebreak,flash,stylescombo,print,preview,save,smiley,pastetext,pastefromword',
			 removeButtons: 'Anchor,Strike,Subscript,Superscript,Table,SpecialChar',
			 strinsert_strings: [],
			 strinsert_button_label: 'Tokens',
			 strinsert_button_title: 'Insert token',
			 custom_tables: [],
			 custom_tables_button_label: 'Custom Tables',
			 custom_tables_button_title: 'Select Custom Tables',
			 allowedContent: true
		   },
		   editorDataToEdit : '<p>Please create your template using the instructions located on the right panel</p>'

		}
	},
	watch:{
		isEditPage() {

		}
	},
	beforeMount(){
	},
	mounted(){


		this.editorConfig.strinsert_strings = this.tokensList;
		if(this.type.type == 'Product'){
			let obj =
				{
					'groupName': 'Product',
					'tables': [
						{	table: productTable,
							name: 'Product Table', label: 'Product Table'
						}
					]
				}

			this.editorConfig.custom_tables.push(obj)
		}
		else if (this.type.type == 'Campaign'){
			let obj =
				{
					'groupName': 'Campaign',
					'tables': [
						{	table: campaignTable,
							name: 'Campaign Table', label: 'Campaign Table'
						}
					]
				}

			this.editorConfig.custom_tables.push(obj)
		}
		else if (this.type.type == 'CampaignGroup'){
			let obj =
				{
					'groupName': 'CampaignGroup',
					'tables': [
						{	table: campaignGroupTemplate,
							name: 'Campaign Group Table', label: 'Campaign Group Table'
						}
					]
				}

			this.editorConfig.custom_tables.push(obj)
		}

		else if (this.type.type == 'Brand Profile'){
			let obj =
				{
					'groupName': 'Brand Profile',
					'tables': [
						{	table: profileTable,
							name: 'Brand Profile Table', label: 'Brand Profile Table'
						}
					]
				}

			this.editorConfig.custom_tables.push(obj)
		}

		if(this.editorData){
			this.editorDataToEdit = this.editorData
		}
	},
	computed:{

	},
	methods:{
		onEditorFocus(){
			if(this.editorDataToEdit == '<p>Please create your template using the instructions located on the right panel</p>\n' ){
				this.editorDataToEdit = ''
			}
		}
	}
}
</script>

<style lang="scss">

.cke_show_borders {
	border : 0px !important;
}


</style>
